import { render, staticRenderFns } from "./Carga-masiva-productos.vue?vue&type=template&id=070c785a"
import script from "./Carga-masiva-productos.vue?vue&type=script&lang=js"
export * from "./Carga-masiva-productos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports